import {logClientError } from "cartovistaExtend/utils/ServerRequests";

    export default class ClientErrorsLogger {
      constructor() {
        this.count = 0;
        this.piwikErrorLogged = false;
        Object.defineProperties(this, {
            "clientInfo": {
                get: function() { return this._getClientInfo(); }
            }
        });
        this._addErrorsEventListeners();
      }

    _addErrorsEventListeners() {
        //handler for global errors (ignore DOMException usually generated by IE)
        window.onerror = _.debounce(function(msg, url, lineNo, columnNo, error) {
            if (!(error instanceof DOMException)) {
                if (C.DEBUG) {
                    console.error(error);
                }
                this.logClientError("ERROR", msg, typeof error.stack != "undefined" ? error.stack : error.toString());
            }
        }.bind(this), C.DEBUG ? 250 : 1000);

        //handler for unhandled errors inside Promises
        window.addEventListener("unhandledrejection", _.debounce(function(error) {
            if (C.DEBUG) {
                console.error(error);
            }
            this.logClientError("ERROR", typeof error.detail != "undefined" ? typeof error.detail.reason.message != "undefined" ? error.detail.reason.message : error.detail.reason : error.reason.message, typeof error.detail != "undefined" ? error.detail.reason.stack : error.reason.stack);
        }.bind(this), C.DEBUG ? 250 : 1000));
    };

    logClientError(errorLevel, msg, stack) {
        this.count++;
        try {
            var clientError = {
                "date" : new Date().toISOString(),
                "clientInfo": this.clientInfo,
                "error": msg,
                "stack": stack,
                "count": this.count,
                "user" : _.has(C, "APP_TOOLS.AUTH_SESSION.USER") ? C.APP_TOOLS.AUTH_SESSION.USER : null
            };
            return logClientError(errorLevel, clientError);
        } catch (error) {
            if (C.DEBUG) {
                console.warn("ClientErrorsLogger.logClientError is not correctly configured");
                console.error(error);
            }
        }
    };

    logPiwikError(error) {
        if (!this.piwikErrorLogged) {
            this.logClientError("WARNING", error.message, error.stack);
            this.piwikErrorLogged = true;
        }
    };

    _getClientInfo() {
        return {
            "location" : window.location.pathname,
            "referer" : document.referrer,
            "navigatorName" : navigator.appName,
            "navigatorProduct" : navigator.product,
            "navigatorVersion" : navigator.appVersion,
            "navigatorUserAgent" : navigator.userAgent,
            "navigatorHardwareConcurrency" : navigator.hardwareConcurrency,
            "navigatorLanguage" : navigator.language,
            "navigatorPlatform" : navigator.platform,
            "screenWidth" : screen.width,
            "screenHeight" : screen.height,
        };
    };

}
